import React from "react";
import {View, Svg, Line, G, Rect, Circle, StyleSheet} from "@react-pdf/renderer";
import MarkDamagesOnTrailerPrintout from "../markDamagesOnTrailerPrintout";
import {SideType} from "../../../../../models/transport";
import {DamageLocation, EquipmentType} from "../../../../../models/tcr";
import {OrderFilesUtils} from "../../../../../../helpers/orderFilesUtils";

const tcrReportStyles = StyleSheet.create(OrderFilesUtils.tcrReportStyles);

export default function Right(): React.ReactElement {
    return (
        <View style={tcrReportStyles.centerPicture}>
            <Svg
                viewBox="0 0 420 213"
                style={tcrReportStyles.pictureSize}
                id="trailer-right"
            >
                <Rect
                    x="1"
                    y="1"
                    width="418"
                    height="141.415"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                />
                <Rect
                    x="354.415"
                    y="141.854"
                    width="13.3659"
                    height="64.5854"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    key="LEG-1"
                />
                <Line
                    x1="323.323"
                    y1="142.647"
                    x2="354.055"
                    y2="168.256"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    key="LEG-2"
                />
                <Line
                    x1="227.927"
                    y1="155.219"
                    x2="315"
                    y2="155.219"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    key="BICYCLE_PROTECTION-2"
                />
                <Line
                    x1="227.927"
                    y1="175.708"
                    x2="315"
                    y2="175.708"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    fill="#ffffff"
                    key="BICYCLE_PROTECTION-1"
                />
                <Circle
                    cx="32.0122"
                    cy="180.549"
                    r="31.0122"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    key="WHEEL__REAR-1"
                />
                <Circle
                    cx="103.719"
                    cy="180.549"
                    r="31.0122"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    stroke-Width="2"
                    key="WHEEL__CENTER-1"
                />
                <Circle
                    cx="172.866"
                    cy="180.549"
                    r="31.0122"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    key="WHEEL__FRONT-1"
                />
                <Circle
                    cx="32.0122"
                    cy="180.549"
                    r="7.96342"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    key="WHEEL__REAR-2"
                />
                <Circle
                    cx="103.72"
                    cy="180.549"
                    r="7.96342"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    key="WHEEL__CENTER-2"
                />
                <Circle
                    cx="172.866"
                    cy="180.549"
                    r="7.96342"
                    fill="#ffffff"
                    stroke="#8E8E8E"
                    strokeWidth="2"
                    key="WHEEL__FRONT-2"
                />
                <Rect
                    fill="#8e8e8e"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="1.47533"
                    width="417.65244"
                    height="16.998671"
                    x="1.1666135"
                    y="125.44902"
                    key="SIDE_BOARD"
                />
                <Rect
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="0.922935"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="209.54654"
                    height="62.077065"
                    x="0.49294969"
                    y="0.51867098"
                    key="TARPAULIN__LEFT_TOP"
                />

                <Rect
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="0.923598"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="209.51569"
                    height="62.163387"
                    x="0.4840509"
                    y="62.547291"
                    key="TARPAULIN__LEFT_BOTTOM"
                />
                <Rect
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="0.92298"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="209.51579"
                    height="62.092644"
                    x="210.03255"
                    y="62.44585"
                    key="TARPAULIN__RIGHT_BOTTOM"
                />
                <Rect
                    fill="#ffffff"
                    fillOpacity={1}
                    fillRule="evenodd"
                    stroke="#8E8E8E"
                    strokeWidth="0.922966"
                    strokeLineCap="butt"
                    strokeDasharray="none"
                    strokeOpacity={1}
                    width="209.51981"
                    height="62.077122"
                    x="210.01581"
                    y="0.40974769"
                    key="TARPAULIN__RIGHT_TOP"
                />
                <G
                    transform="translate(-41.573807,-6.484322)"
                    key="TARPAULIN__LEFT_TOP.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.RIGHT}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.LEFT_TOP}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(183.17619,-7.734322)"
                    key="TARPAULIN__RIGHT_TOP.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.RIGHT}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.RIGHT_TOP}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(-41.573807,55.765678)"
                    key="TARPAULIN__LEFT_BOTTOM.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.RIGHT}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.LEFT_BOTTOM}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(183.42619,55.265678)"
                    key="TARPAULIN__RIGHT_BOTTOM.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.RIGHT}
                        equipmentType={EquipmentType.TARPAULIN}
                        damageLocation={DamageLocation.RIGHT_BOTTOM}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(72.67619,99.01568)"
                    key="SIDE_BOARD.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.RIGHT}
                        equipmentType={EquipmentType.SIDE_BOARD}
                        damageLocation={null}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(36.67619,141.51568)"
                    key="WHEEL__FRONT.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.RIGHT}
                        equipmentType={EquipmentType.WHEEL}
                        damageLocation={DamageLocation.FRONT}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(-32.82381,142.01568)"
                    key="WHEEL__CENTER.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.RIGHT}
                        equipmentType={EquipmentType.WHEEL}
                        damageLocation={DamageLocation.CENTER}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(-105.07381,141.26568)"
                    key="WHEEL__REAR.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.RIGHT}
                        equipmentType={EquipmentType.WHEEL}
                        damageLocation={DamageLocation.REAR}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(132.67619,133.62964)"
                    key="BICYCLE_PROTECTION.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.RIGHT}
                        equipmentType={EquipmentType.BICYCLE_PROTECTION}
                        damageLocation={null}
                        fontSize={16}
                        textY="46"
                    />
                </G>
                <G
                    transform="translate(227.92619,141.01568)"
                    key="LEG.damage"
                >
                    <MarkDamagesOnTrailerPrintout
                        sideType={SideType.RIGHT}
                        equipmentType={EquipmentType.LEG}
                        damageLocation={null}
                        fontSize={16}
                        textY="46"
                    />
                </G>
            </Svg>
        </View>
    );
}